import React, { useEffect, useState } from "react";
import CuerpoPrincipal from "../elementos/basicos/CuerpoPrincipal";

import EnhancedTable from "../elementos/basicos/TablaCursosConvocatoria";
import { fechtOptenerModelos, fetchCursosConvocatoriaFilters, fetchSubcategorias, fetchActualizarCursos } from '../../peticiones_API/PeticionesCursoConvocatoria';
import { useLocation, useNavigate } from 'react-router-dom';
import IconosGenerales from "../elementos/iconos/IconosGenerales";
import Navbar from "../elementos/cuerpo/Navbar";
import { ConfirmacionEliminar } from '../elementos/eventos/avisos/VentanaEmergente';
import Titulo from "../elementos/basicos/Titulo";
import styled from 'styled-components';

const GestorCursosConvocatoria = (props) => {
    console.log("props",props);
    const location = useLocation();
    let params = new URLSearchParams(location.search);
    let paginaActual = parseInt(params.get("pagina"));
    let registrosPorPag = parseInt(params.get("registrosPorPag"));
    let categoria = params.get("categoria");
    let subcategoria = params.get("subcategoria");

    let busqueda = params.get("busqueda") || null;
    let proveedor = params.get("proveedor");
    let nivel = params.get("nivel");
    let plazas = params.get("plazas");
    let activo = params.get("activo");
    let ordenarColumna = params.get("ordenarColumna");
    let orden = params.get("orden");

    const [loading, setLoading] = useState(true);
    const [cargaActiva, setCargaActiva] = useState(true);

    const urlPadre = window.location.pathname;
    const navigate = useNavigate();
    const [data, setData] = useState({
        meta: {},
        rows: []
    });
    const [proveedores, setProveedores] = useState();
    const [categorias, setcategorias] = useState();
    const [subcategorias, setSubcategorias] = useState([]);
    const [requisitos, setRequisitos] = useState();
    const [conPlazas, setConPlazas] = useState(1);
    const [esActivo, setEsActivo] = useState(1);
    const [selected, setSelected] = useState([]);
    const [ocultarFiltroTodos, setOcultarFiltroTodos] = useState({ atributo: 'visible', valor: null });
    const [ocultarSeleccion, setOcultarSeleccion] = useState({ atributo: 'visible', valor: null });
    const [activarFiltroTodos, setActivarFiltroTodos] = useState({ atributo: 'activo', valor: null });
    const [activarSeleccion, setActivarSeleccion] = useState({ atributo: 'activo', valor: null });


    const confirmDialog = ConfirmacionEliminar();

    useEffect(() => {
        async function fechtActualizarFiltros() {
            console.log("Entra en el filtro");

            try {
                if (
                    ocultarFiltroTodos.valor == false ||
                    ocultarSeleccion.valor == false ||
                    activarFiltroTodos.valor == true ||
                    activarSeleccion.valor == true
                ) {
                    let mensaje = "";

                    if (ocultarFiltroTodos.valor === false || ocultarSeleccion.valor === false) {
                        mensaje = "eliminar";
                    } else if (activarFiltroTodos.valor === true || activarSeleccion.valor === true) {
                        mensaje = "activar";
                    }

                    const confirm = await confirmDialog.showAlert(mensaje,"cursos");

                    if (confirm) {
                        let cursosActualizar = [];


                        if (ocultarFiltroTodos.valor == false) {
                            setOcultarFiltroTodos((prevState) => ({
                                ...prevState,
                                valor: null,
                            }));

                            const cursosResponse = await fetchCursosConvocatoriaFilters(
                                paginaActual,
                                data.meta.total,
                                proveedor,
                                nivel,
                                plazas,
                                activo,
                                categoria,
                                subcategoria,
                                busqueda,
                                ordenarColumna,
                                orden
                            );

                            cursosResponse.data.forEach((curso) => {
                                cursosActualizar.push(curso.Id);
                            });

                            console.log("Entra en condición de ocultar todos");
                            await fetchActualizarCursos(cursosActualizar, ocultarFiltroTodos);
                        }


                        if (ocultarSeleccion.valor == false && selected.length !== 0) {
                            setOcultarSeleccion((prevState) => ({
                                ...prevState,
                                valor: null,
                            }));

                            cursosActualizar = selected;
                            await fetchActualizarCursos(cursosActualizar, ocultarSeleccion);
                        }


                        if (activarFiltroTodos.valor === true) {
                            setActivarFiltroTodos((prevState) => ({
                                ...prevState,
                                valor: null,
                            }));

                            const cursosResponse = await fetchCursosConvocatoriaFilters(
                                paginaActual,
                                data.meta.total,
                                proveedor,
                                nivel,
                                plazas,
                                activo,
                                categoria,
                                subcategoria,
                                busqueda,
                                ordenarColumna,
                                orden
                            );

                            cursosResponse.data.forEach((curso) => {
                                cursosActualizar.push(curso.Id);
                            });

                            console.log("Entra en condición de activar todos");
                            await fetchActualizarCursos(cursosActualizar, activarFiltroTodos);
                        }


                        if (activarSeleccion.valor == true && selected.length !== 0) {
                            setActivarSeleccion((prevState) => ({
                                ...prevState,
                                valor: null,
                            }));

                            cursosActualizar = selected;
                            console.log("activarSeleccion", activarSeleccion);
                            await fetchActualizarCursos(cursosActualizar, activarSeleccion);
                        }

                        const cursosResponse = await fetchCursosConvocatoriaFilters(
                            paginaActual,
                            registrosPorPag,
                            proveedor,
                            nivel,
                            plazas,
                            activo,
                            categoria,
                            subcategoria,
                            busqueda,
                            ordenarColumna,
                            orden
                        );

                        const { data: cursosData, meta } = cursosResponse;

                        setData({
                            meta,
                            rows: formatData(cursosData),
                        });

                        setSelected([]);

                        const params = new URLSearchParams();
                        params.append('pagina', paginaActual);
                        params.append('registrosPorPag', registrosPorPag);
                        if (proveedor) params.append('proveedor', proveedor);
                        if (nivel) params.append('nivel', nivel);
                        if (plazas) params.append('plazas', plazas);
                        if (activo) params.append('activo', activo);
                        if (categoria) params.append('categoria', categoria);
                        if (subcategoria) params.append('subcategoria', subcategoria);
                        if (busqueda) params.append('busqueda', busqueda);
                        if (ordenarColumna) params.append('ordenarColumna', ordenarColumna);
                        if (orden) params.append('orden', orden);

                        navigate(`${urlPadre}?${params.toString()}`);
                    } else {
                        
                        setOcultarFiltroTodos((prevState) => ({
                            ...prevState,
                            valor: null,
                        }));
                        setOcultarSeleccion((prevState) => ({
                            ...prevState,
                            valor: null,
                        }));
                        setActivarFiltroTodos((prevState) => ({
                            ...prevState,
                            valor: null,
                        }));
                        setActivarSeleccion((prevState) => ({
                            ...prevState,
                            valor: null,
                        }));
                    }
                }
            } catch (error) {
                console.error("Error al actualizar filtros:", error);
            }
        }



        if (
            ocultarFiltroTodos.valor !== null ||
            ocultarSeleccion.valor !== null ||
            activarFiltroTodos.valor !== null ||
            activarSeleccion.valor !== null
        ) {
            fechtActualizarFiltros();
        }
    }, [ocultarFiltroTodos, ocultarSeleccion, activarFiltroTodos, activarSeleccion, paginaActual, registrosPorPag, proveedor, nivel, plazas, activo, categoria, subcategoria, busqueda, ordenarColumna, orden, selected]);

    useEffect(() => {
        async function fechtPrincipal() {
            setLoading(true); 
            try {
                const listadoResponse = await fechtOptenerModelos(["Requisito", "Proveedores", "Categoria"], true);
                setcategorias(listadoResponse.Categoria);
                setProveedores(listadoResponse.Proveedores);
                setRequisitos(listadoResponse.Requisito);

                if (categoria) {
                    const subcategoriasResponse = await fetchSubcategorias(categoria);
                    setSubcategorias(subcategoriasResponse[0].SubCategoria);
                }

                let cursosResponse;
                if (!paginaActual || !registrosPorPag || !plazas || !activo) {
                    cursosResponse = await fetchCursosConvocatoriaFilters(paginaActual, registrosPorPag);
                    const { data: cursosData, meta } = cursosResponse;
                    paginaActual = meta.current_page;
                    registrosPorPag = meta.per_page;
                    plazas = 1;
                    activo = 1;
                    navigate(`${urlPadre}?pagina=${paginaActual}&registrosPorPag=${registrosPorPag}&plazas=${plazas}&activo=${activo}`);
                    setData({ meta, rows: formatData(cursosData) });
                } else {
                    cursosResponse = await fetchCursosConvocatoriaFilters(
                        paginaActual, registrosPorPag, proveedor, nivel, plazas, activo, categoria, subcategoria, busqueda, ordenarColumna, orden
                    );
                    const { data: cursosData, meta } = cursosResponse;
                    setData({ meta, rows: formatData(cursosData) });
                }

                setLoading(false);
            } catch (error) {
                console.log("Ha habido un error:", error);
            }
        }

        fechtPrincipal();
    }, [paginaActual, registrosPorPag, proveedor, nivel, plazas, activo, categoria, subcategoria, busqueda, ordenarColumna, orden, navigate, urlPadre]);

    const formatData = (data) => {
        console.log("data ", data);
        return data.map((row) => ({
            id: row.Id,
            nombre: row.nombre,
            AF: row.AF,
            proveedor: row?.proveedor?.nombre,
            activo: row.activo,
            NumPlazas: row.numPlazas,
            plazasAgotadas:row.plazasAgotadas,
            categoria: row?.Categoria?.categoria,
            subcategoria: row.SubCategorium ? row.SubCategorium.nombre : null,
            horas: row.horas,
            nivel: row.nivel,
            editar: row.Id
        }));
    };

    const header = [
        {
            id: 'nombre',
            numeric: false,
            disablePadding: true,
            label: 'Nombre',
        },
        {
            id: 'AF',
            numeric: false,
            disablePadding: false,
            label: 'AF',
        },
        {
            id: 'Proveedor',
            numeric: false,
            disablePadding: false,
            label: 'Proveedor',
        },
        {
            id: 'NumPlazas',
            numeric: true,
            disablePadding: false,
            label: 'Nº plazas',
        },
        {
            id: 'Categoria',
            numeric: true,
            disablePadding: false,
            label: 'Categoria',
        },
        {
            id: 'SubCategorium',
            numeric: true,
            disablePadding: false,
            label: 'Subcategoria',
        },
        {
            id: 'horas',
            numeric: true,
            disablePadding: false,
            label: 'Horas',
        },
        {
            id: 'nivel',
            numeric: true,
            disablePadding: false,
            label: 'Nivel',
        },
        {
            id: 'modificar',
            numeric: true,
            disablePadding: false,
            label: '',
        }
    ];


    return (
        <>
            
                <CabeceraForm>
                    <Titulo
                        texto="CURSOS"
                        convocatoria="true"
                        tituloTabla="true"
                    />
                </CabeceraForm>

                <EnhancedTable
                    data={data.rows}
                    header={header}
                    meta={data.meta}
                    proveedores={proveedores}
                    categorias={categorias}
                    subcategorias={subcategorias}
                    requisitos={requisitos}
                    conPlazas={conPlazas}
                    activo={esActivo}
                    selected={selected}
                    setSelected={setSelected}
                    ocultarFiltroTodos={ocultarFiltroTodos}
                    setOcultarFiltroTodos={setOcultarFiltroTodos}
                    ocultarSeleccion={ocultarSeleccion}
                    setOcultarSeleccion={setOcultarSeleccion}
                    activarFiltroTodos={activarFiltroTodos}
                    setActivarFiltroTodos={setActivarFiltroTodos}
                    activarSeleccion={activarSeleccion}
                    setActivarSeleccion={setActivarSeleccion}
                    isLoading={loading}
                    busqueda={busqueda}
                />
        </>
    );
}


const CabeceraForm = styled.div`
    margin: 5% 0% 1% 0%;
`
export default GestorCursosConvocatoria;